export default "__VITE_ASSET__DCe6vds6__"